export default class EventAdditonalPriceTypes {
    static modelName = 'EventAdditonalPriceTypes';
                        
    id: number
    active: boolean = true
    priceTypeDescription: string
    [key: string]: any
}